<template>
  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" class="w-6 h-6">
    <circle cx="16" cy="16" r="15" fill="#1e92cf"/>
    <path d="M9 19l7-7 7 7" stroke="white" stroke-width="4" fill="none"/>
  </svg>
</template>

<script>
export default {
    name: "IconLocationChevronUp"
}
</script>
